import React from 'react'
import TextField from '@mui/material/TextField';

export interface InputProps {
    placeholder?: string;
    multiline?: boolean;
    variant: 'outlined' | 'filled' | 'standard';
    style?: React.CSSProperties;
    onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
    onKeyDown?: (event: React.KeyboardEvent<HTMLInputElement>) => void;
    value?: string,
    disabled?: boolean;
}

const Input = ({
  placeholder = 'Type your message here...',
  multiline = true,
  variant = 'outlined', 
  value = '',
  disabled = false,
  onKeyDown = () => {},
  onChange = () => { }, style }: InputProps
) => {
  return (
    <div data-testid='input-container-div'>
      <TextField 
        data-testid='input-text-field'
        placeholder={placeholder}
        multiline={multiline}
        variant={variant}
        style={style}
        onChange={onChange}
        onKeyUpCapture={onKeyDown}
        type='time'
        value={value}
        disabled={disabled}
      />
    </div>
 )
}

export default Input

